function MeedyAddressWrapper(apartment, city, number, state, street, zipCode) {
    this.apartment = apartment;
    this.city = city;
    this.number = number;
    this.state = state;
    this.street = street;
    this.zipCode = zipCode;

    var _typeContext = {
        state: MeedyStateWrapper
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}